"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const NativeSelectTypes_1 = __importDefault(require("../enums/NativeSelectTypes"));
const Zupicons_1 = __importDefault(require("../enums/Zupicons"));
const Icon_1 = __importDefault(require("./Icon"));
class NativeSelect extends react_1.default.Component {
    render() {
        const { alwaysShowPlaceholder, className, disabled, noOptionPreselected, noOptionEnabled, onChange, options, placeholder, required, type, value, } = this.props;
        const randomId = 'znd-native-select-' + Math.floor(Math.random() * 100000000);
        const optionsArray = Array.isArray(options)
            ? options
            : Object.entries(options).map(([optionValue, optionLabel]) => ({ value: optionValue, label: optionLabel }));
        const selectedOption = optionsArray.find((option) => option.value === value);
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-native-select', {
                'znd-native-select--cart-line-item-quantity': type === NativeSelectTypes_1.default.cartLineItemQuantity,
            }, className) },
            !disabled ? react_1.default.createElement(Icon_1.default, { className: "znd-native-select__icon", name: Zupicons_1.default.angleDown }) : null,
            react_1.default.createElement("label", { className: (0, classnames_1.default)('znd-native-select__label', {
                    'znd-native-select__label--selected': !disabled && !alwaysShowPlaceholder && !!value && !!selectedOption,
                }), htmlFor: randomId }, !!alwaysShowPlaceholder ? placeholder : (selectedOption?.label ?? placeholder)),
            react_1.default.createElement("select", { className: "znd-native-select__select", id: randomId, value: value, disabled: disabled ?? false, onChange: (event) => onChange(event.target.value), required: required },
                noOptionPreselected ? (react_1.default.createElement("option", { value: "", ...(noOptionEnabled ? null : { disabled: true }) }, placeholder)) : null,
                optionsArray
                    .filter((option) => option.value !== 'undefined')
                    .map((option) => (react_1.default.createElement("option", { className: "znd-native-select__option", value: option.value, key: option.value }, option.label))))));
    }
}
exports.default = NativeSelect;
